import React from 'react';
import withForm from 'components/form/hoc/with-form';
import {
  Container,
  Option,
  Slider,
} from 'routes/surface/components/node-modal-form/components/ris-search-modal/components/tabbed-options/style';
import useEventListener from 'hooks/use-event-listener';

interface OptionProps {
  label: string;
  value: string | number;
}

function calculateStyles(node) {
  if (node) {
    const parent = node.parentElement.getBoundingClientRect();
    const rect = node.getBoundingClientRect();

    return {
      left: rect.left - parent.left,
      width: rect.width,
    };
  } else {
    return {};
  }
}

function TabbedOptions(props) {
  const { options, onChange } = props;
  const [node, setNode] = React.useState(null);
  const setSelectedElement = React.useCallback((node) => setNode(node), []);
  const resizeHandler = () => setNode(node);

  useEventListener('resize', resizeHandler);

  return (
    <Container>
      {options.map(({ value, label }: OptionProps) => (
        <Option
          key={value}
          onClick={() => onChange(value)}
          isSelected={props.value === value}
          ref={(element) =>
            props.value === value && setSelectedElement(element)
          }>
          {label}
        </Option>
      ))}
      <Slider {...calculateStyles(node)} />
    </Container>
  );
}

export default withForm(TabbedOptions);
